import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokhandalataxifare() {



    const cardData = {




keyword: "Mumbai to Khandala Taxi Fare",

headingDescription: "Shreesha Tours & Travels provides affordable and transparent Mumbai to Khandala taxi fare services with comfortable travel options for families, couples, tourists, corporate travelers, and weekend vacationers. We offer one-way cabs, round-trip taxi services, same-day return trips, and customized outstation packages with experienced chauffeurs and well-maintained vehicles. Our fleet includes Sedan, Swift Dzire, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, Urbania, Mini Bus, and luxury cars suitable for different travel needs and group sizes. With doorstep pickup anywhere in Mumbai, competitive taxi fares, flexible travel timings, easy booking, and 24/7 customer support, Shreesha Tours & Travels ensures a safe, comfortable, and hassle-free journey. Whether you are planning a hill station getaway, family outing, corporate trip, romantic weekend, or sightseeing tour, our Mumbai to Khandala taxi service offers clean vehicles, professional drivers, and reliable service at affordable rates. Enjoy a scenic drive through the Mumbai–Pune Expressway while exploring the beautiful valleys, viewpoints, waterfalls, and attractions of Khandala.",

topPlaces: [
  {
    title: "Duke's Nose Point",
    description: "Duke's Nose Point is one of Khandala's most famous viewpoints, named after its unique cliff shape resembling a nose. It offers breathtaking views of the Sahyadri mountains, valleys, and winding roads, making it a popular destination for trekking, photography, and adventure lovers."
  },
  {
    title: "Rajmachi Point",
    description: "Rajmachi Point is a scenic viewpoint near Khandala offering beautiful views of Rajmachi Fort, lush green valleys, and surrounding mountains. It is an ideal stop for travelers who want to enjoy nature, photography, and peaceful landscapes."
  },
  {
    title: "Tiger's Leap",
    description: "Tiger's Leap, also known as Tiger Point, is a spectacular cliff-top viewpoint famous for its valley views, sunrise and sunset scenes, and monsoon beauty. The location attracts tourists looking for breathtaking views and memorable hill station experiences."
  },
  {
    title: "Karla Caves",
    description: "Karla Caves are ancient Buddhist rock-cut caves located near Khandala and are famous for their historic architecture, intricate carvings, and impressive Chaitya hall. The caves are a major attraction for history enthusiasts and tourists exploring the region."
  },
  {
    title: "Bhaja Caves",
    description: "Bhaja Caves are ancient Buddhist caves surrounded by beautiful hills and greenery. The site features rock-cut monuments, stupas, and historical sculptures, making it an excellent destination for heritage lovers and travelers interested in ancient architecture."
  },
  {
    title: "Bhushi Dam",
    description: "Bhushi Dam near Khandala and Lonavala is a popular monsoon attraction known for overflowing water steps, scenic surroundings, and a fun picnic atmosphere. Families, friends, and tourists frequently visit this spot during the rainy season."
  },
  {
    title: "Amrutanjan Point",
    description: "Amrutanjan Point is a beautiful viewpoint located at the entrance of Khandala, offering panoramic views of valleys, mountains, and the expressway. It is a peaceful stop for travelers to enjoy the natural beauty of the Western Ghats."
  },
  {
    title: "Lohagad Fort",
    description: "Lohagad Fort is a historic hill fort near Khandala and Lonavala, known for trekking trails, ancient architecture, and spectacular monsoon landscapes. It is a favorite destination for adventure enthusiasts and history lovers."
  },
  {
    title: "Pawna Lake",
    description: "Pawna Lake is a scenic camping destination near Khandala famous for lakeside stays, boating, photography, and beautiful sunset views. It is perfect for couples, families, and groups looking for a peaceful weekend escape."
  },
  {
    title: "Lonavala",
    description: "Lonavala is a popular hill station near Khandala known for waterfalls, viewpoints, caves, lakes, and pleasant weather. Many travelers combine Khandala and Lonavala in a single trip to experience the best attractions of the Sahyadri region."
  }
],



"services": [
  {
    "name": "Mumbai to Khandala Taxi",
    "description": "Book Mumbai to Khandala Taxi for safe, comfortable, and reliable hill station travel with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Ertiga, Innova, Innova Crysta, SUV, and premium cab options for weekend getaways, family vacations, sightseeing trips, and relaxing journeys from Mumbai to Khandala with flexible one way and round trip booking facilities."
  },
  {
    "name": "Mumbai to Khandala Cab",
    "description": "Hire Mumbai to Khandala Cab service for a smooth and enjoyable journey with experienced drivers, clean vehicles, and affordable travel packages. Our chauffeur-driven cabs provide comfortable transportation for couples, families, corporate outings, and tourists planning a peaceful trip to Khandala hill station."
  },
  {
    "name": "Mumbai to Khandala Taxi Fare",
    "description": "Check Mumbai to Khandala Taxi Fare with transparent pricing, affordable packages, and reliable cab services. Get comfortable travel options with professional drivers, premium vehicles, and flexible fare plans for one way trips, round trips, and customized Khandala tours."
  },
  {
    "name": "Mumbai to Khandala Cab Fare",
    "description": "Get Mumbai to Khandala Cab Fare with competitive pricing and quality transportation services. Travel comfortably with experienced chauffeurs, clean AC cars, and multiple vehicle options suitable for family trips, sightseeing, weekend holidays, and personal travel requirements."
  },
  {
    "name": "Mumbai to Khandala Cab Service",
    "description": "Book Mumbai to Khandala Cab Service with doorstep pickup, professional chauffeurs, comfortable AC vehicles, and flexible travel schedules. Enjoy a hassle-free journey for weekend trips, family holidays, corporate travel, and sightseeing between Mumbai and Khandala."
  },
  {
    "name": "Mumbai to Khandala Taxi Service",
    "description": "Choose Mumbai to Khandala Taxi Service for dependable transportation with skilled drivers, well-maintained vehicles, and affordable travel solutions. Enjoy a smooth hill station journey with Sedan, Ertiga, Innova Crysta, and SUV taxi options."
  },
  {
    "name": "Mumbai to Khandala Cab Booking",
    "description": "Complete Mumbai to Khandala Cab Booking online with quick confirmation, easy reservations, and multiple vehicle choices. Select your preferred cab according to passenger count, luggage requirements, and travel plans for a comfortable and memorable Khandala trip."
  },
  {
    "name": "Mumbai to Khandala Car Rental",
    "description": "Choose Mumbai to Khandala Car Rental for private chauffeur-driven vehicles with comfortable interiors and professional service. Ideal for family vacations, corporate outings, sightseeing tours, honeymoon trips, and customized hill station travel packages from Mumbai."
  },
  {
    "name": "Mumbai to Khandala One Way Taxi",
    "description": "Book Mumbai to Khandala One Way Taxi for economical single-direction travel without return charges. Enjoy fixed pricing, clean vehicles, comfortable seating, and professional chauffeur service for a convenient and budget-friendly journey."
  },
  {
    "name": "Mumbai to Khandala Round Trip Cab",
    "description": "Reserve Mumbai to Khandala Round Trip Cab for convenient return travel with flexible schedules and affordable packages. Perfect for weekend getaways, family outings, sightseeing tours, and relaxing vacations with comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Mumbai Airport to Khandala Taxi",
    "description": "Book Mumbai Airport to Khandala Taxi for timely airport pickup and drop services with professional drivers and comfortable vehicles. Enjoy stress-free airport transfers with Sedan, Ertiga, Innova Crysta, and SUV cab options for individuals and families."
  },
  {
    "name": "Navi Mumbai to Khandala Cab",
    "description": "Reserve Navi Mumbai to Khandala Cab for reliable travel with experienced chauffeurs, clean AC cars, and affordable pricing. Get convenient pickup services from Navi Mumbai areas for family trips, weekend holidays, and sightseeing journeys."
  },
  {
    "name": "Thane to Khandala Taxi",
    "description": "Choose Thane to Khandala Taxi for comfortable and affordable transportation with professional drivers and well-maintained vehicles. Enjoy a smooth journey from Thane to Khandala with flexible booking options for personal and family travel."
  },
  {
    "name": "Panvel to Khandala Cab",
    "description": "Book Panvel to Khandala Cab with convenient pickup options, experienced chauffeurs, and comfortable vehicles. Travel safely to Khandala with reliable cab services designed for weekend trips, sightseeing, and private journeys."
  },
  {
    "name": "Mumbai to Khandala Outstation Cab",
    "description": "Hire Mumbai to Khandala Outstation Cab for safe and comfortable long-distance travel with skilled drivers and premium AC vehicles. Enjoy reliable one way and round trip transportation with flexible packages for tourists and families."
  },
  {
    "name": "Mumbai to Khandala Tourist Taxi",
    "description": "Book Mumbai to Khandala Tourist Taxi for customized sightseeing trips with experienced drivers and comfortable vehicles. Explore Khandala attractions with private transportation, flexible schedules, and convenient travel packages."
  },
  {
    "name": "Mumbai Lonavala Khandala Cab Service",
    "description": "Choose Mumbai Lonavala Khandala Cab Service for comfortable hill station tours covering both Lonavala and Khandala destinations. Enjoy private cab facilities with professional chauffeurs, premium vehicles, and flexible sightseeing packages for families, couples, and groups."
  },
  {
    "name": "Best Mumbai to Khandala Taxi Booking",
    "description": "Choose Best Mumbai to Khandala Taxi Booking service with trained drivers, quality vehicles, affordable fares, and dependable customer support. Enjoy safe, comfortable, and convenient transportation solutions for Khandala sightseeing, weekend trips, family tours, and holiday journeys."
  }
],
"tableData": [
  ["Mumbai to Khandala Taxi", "Mumbai to Khandala Cab"],
  ["Mumbai to Khandala Taxi Fare", "Mumbai to Khandala Cab Fare"],
  ["Mumbai to Khandala Cab Service", "Mumbai to Khandala Taxi Service"],
  ["Mumbai to Khandala Cab Booking", "Mumbai to Khandala Car Rental"],
  ["Mumbai to Khandala One Way Taxi", "Mumbai to Khandala Round Trip Cab"],
  ["Mumbai Airport to Khandala Taxi", "Navi Mumbai to Khandala Cab"],
  ["Thane to Khandala Taxi", "Panvel to Khandala Cab"],
  ["Mumbai to Khandala Outstation Cab", "Mumbai to Khandala Tourist Taxi"],
  ["Mumbai Lonavala Khandala Cab Service", "Best Mumbai to Khandala Taxi Booking"]
],




whychoose: [
  {
    WhyChooseheading: "Affordable Mumbai to Khandala Taxi Fare with Comfortable Travel",
    WhyChoosedescription: "Shreesha Tours & Travels offers competitive Mumbai to Khandala taxi fare options with comfortable vehicles, experienced drivers, and flexible packages suitable for weekend trips, family outings, and business travel."
  },
  {
    WhyChooseheading: "Transparent Pricing for Khandala Cab Booking",
    WhyChoosedescription: "Get clear and convenient fare details for Mumbai to Khandala taxi service without hidden surprises, making it easier to plan your travel budget."
  },
  {
    WhyChooseheading: "Choose Vehicles According to Your Budget",
    WhyChoosedescription: "Select from economical Sedan cars, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options based on passenger count and comfort needs."
  },
  {
    WhyChooseheading: "Ideal for Weekend Trips & Short Holidays",
    WhyChoosedescription: "A Mumbai to Khandala taxi is a perfect choice for quick getaways, family vacations, couple trips, and relaxing hill station visits."
  },
  {
    WhyChooseheading: "Experienced Drivers for Expressway & Ghat Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with Mumbai–Khandala routes and provide a safe, smooth, and comfortable journey through highway and hill roads."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose a one-way drop, return taxi, or customized travel package depending on your schedule and travel requirements."
  },
  {
    WhyChooseheading: "Sightseeing Cab Options Available",
    WhyChoosedescription: "Customize your Khandala trip with nearby attractions like Duke's Nose, Tiger Point, Amby Valley, Rajmachi Point, Lonavala Lake, and other scenic locations."
  },
  {
    WhyChooseheading: "Easy Fare Enquiry with Shreesha Tours & Travels",
    WhyChoosedescription: "Get quick assistance for Mumbai to Khandala taxi fare enquiries with simple booking support and reliable travel arrangements."
  }
]

};

const faqData = [
  {
    question: "How is Mumbai to Khandala taxi fare calculated?",
    answer: "The taxi fare depends on vehicle type, trip duration, travel distance, selected package, and whether you choose one-way or round-trip service."
  },
  {
    question: "Can I get an affordable Mumbai to Khandala cab?",
    answer: "Yes, different vehicle options are available to match various budgets and travel requirements."
  },
  {
    question: "Which cars are available for Mumbai to Khandala taxi booking?",
    answer: "You can choose Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, and Tempo Traveller options."
  },
  {
    question: "Is Mumbai to Khandala taxi suitable for a weekend trip?",
    answer: "Yes, Khandala cab service is ideal for weekend holidays, family outings, romantic trips, and short vacations."
  },
  {
    question: "Can I book a one-way Mumbai to Khandala taxi?",
    answer: "Yes, one-way taxi service is available for travellers who need direct transportation."
  },
  {
    question: "Are round-trip taxi packages available for Khandala?",
    answer: "Yes, round-trip and same-day return cab packages are available according to your travel plan."
  },
  {
    question: "Can I add Lonavala sightseeing with my Khandala cab?",
    answer: "Yes, nearby sightseeing places around Khandala and Lonavala can be included in your customized itinerary."
  },
  {
    question: "Do you provide pickup from Mumbai Airport or hotels?",
    answer: "Yes, pickup is available from Mumbai Airport, railway stations, hotels, offices, homes, and preferred locations."
  },
  {
    question: "Are toll and parking charges included in Mumbai to Khandala taxi fare?",
    answer: "Applicable tolls, parking fees, permits, and additional charges depend on the selected package and are explained before booking."
  },
  {
    question: "How can I check Mumbai to Khandala taxi fare and book a cab?",
    answer: "Share your travel date, pickup location, passenger details, and preferred vehicle type to get fare details and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nitin Sharma",
    feedback: "I checked Mumbai to Khandala taxi fare with Shreesha Tours & Travels and got a suitable option quickly. The cab was clean, and the driver provided a comfortable journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Deshmukh",
    feedback: "Our family trip to Khandala was very enjoyable. The Innova Crysta was spacious, the driver was professional, and the complete travel arrangement was smooth.",
    rating: 5
  }
];
























    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khandala Taxi Fare",
  "image": "https://www.shreeshatravels.com/assets/images/mumbai-to-khandala-taxi-fare.webp",
  "description":
    "Book Mumbai to Khandala Taxi Fare with Shreesha Tours & Travels for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Mumbai to Khandala with Sedan, Ertiga, SUV, Innova, and Innova Crysta available 24x7 for weekend getaways, hill station trips, sightseeing, corporate travel, and family vacations.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/mumbai-to-khandala-taxi-fare"
  }
};







    return (
        <div>

<Helmet>
  <title>Mumbai to Khandala Taxi Fare | Budget Cab Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Mumbai to Khandala Taxi Fare with Shreesha Travels for reliable one-way and round-trip taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for affordable travel from Mumbai to Khandala with transparent fares and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Mumbai to Khandala Taxi, Mumbai to Khandala Cab, Mumbai to Khandala Taxi Fare, Mumbai to Khandala Cab Service, Mumbai to Khandala Taxi Service, Mumbai to Khandala One Way Cab, Mumbai to Khandala Round Trip Cab, Mumbai to Khandala Cab Booking, Mumbai to Khandala Taxi Booking, Mumbai to Khandala Car Rental, Mumbai to Khandala Outstation Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/20.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitokhandalataxifare;